import React from 'react';
import { Globe } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * Badge that indicates a page is accessible to guests (non-logged-in users)
 * Only shows when user is NOT logged in
 */
const GuestAccessibleBadge = ({ className = '' }) => {
  const { user } = useAuth();
  
  // Only show to guests (non-logged-in users)
  if (user) return null;

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 bg-emerald-50 text-emerald-700 rounded-full text-xs font-medium ${className}`}>
      <Globe className="w-3 h-3" />
      Open to guests
    </span>
  );
};

export default GuestAccessibleBadge;
